export default __webpack_public_path__ + "static/N0238-00b696fbbc78c5ae05a0337aaad7f61f.png";